import React from 'react';
import PropTypes from 'prop-types';

import Link from '@mui/material/Link';

import {useLazyGetSimilarResourceSearchQuery} from 'api';
import {connect} from 'react-redux';
import {
  searchPerformedOnSelector,
  setInputData,
  setInputDataType,
  setIsOrganizationSearchParameterShown,
  setIsOrganizationSearchParameterBarOpened
} from 'redux/slices/searchFormSlice';
import {
  setResultData,
  setResourcesData,
  setIsResultDataFetching,
  setNotFoundError,
  setIsSearchResultDataError
} from 'redux/slices/searchResultsSlice';
import {setAuthError, rightsSelector} from 'redux/slices/appSlice';
import {setIsSimilarResourceSearch, setResourceId, setSearchedType} from 'redux/slices/similarResourceSearchSlice';

import {SEARCH_PARAMETER_TYPES, PATIENT, BSN} from 'constants.js';

const SimilarResourceSearch = ({
  system,
  value,
  resourceId,
  searchPerformedOn,
  rights,
  setSearchResultsResultData,
  setSearchResultsResourcesData,
  setSearchResultsNotFoundError,
  setSearchResultsIsSearchResultDataError,
  setSearchResultsIsResultDataFetching,
  setAppAuthError,
  setSearchFormInputData,
  setSearchFormInputDataType,
  setSearchFormIsOrganizationSearchParameterShown,
  setSearchFormIsOrganizationSearchParameterBarOpened,
  setSimilarResourceSearchIsSimilarResourceSearch,
  setSimilarResourceSearchResourceId,
  setSimilarResourceSearchSearchedType
}) => {
  const [getSimilarResourceSearch] = useLazyGetSimilarResourceSearchQuery();

  const getSimilarResource = (resourceType, id, identifierSystem) => {
    setSearchResultsResultData({});
    setSearchResultsResourcesData({});

    if (searchPerformedOn == PATIENT) {
      setSearchFormIsOrganizationSearchParameterShown(true);
      setSearchFormIsOrganizationSearchParameterBarOpened(false);
    }

    setSearchResultsIsResultDataFetching(true);

    const searchFormInputDataType = getSearchFormInputDataTypeFromIdentifierSystem(identifierSystem);
    setSearchFormInputDataType(searchFormInputDataType);
    if (searchFormInputDataType === BSN) setSearchFormInputData('');
    else setSearchFormInputData(value);

    setSimilarResourceSearchIsSimilarResourceSearch(true);
    setSimilarResourceSearchResourceId(resourceId);
    setSimilarResourceSearchSearchedType(searchFormInputDataType);

    getSimilarResourceSearch({resourceType, id, identifierSystem}).then((resultData) => {
      setSearchResultsIsResultDataFetching(false);

      if (resultData.error) {
        if (resultData.error?.status === 401) setAppAuthError({is: true, errorScope: !rights.search});
        else {
          setSearchResultsIsSearchResultDataError(true);
          setSearchResultsResultData({});
        }
      } else if (resultData.data && resultData.data.count > 0) {
        setSearchResultsResultData(resultData.data);
        setSearchResultsNotFoundError(false);
      } else {
        setSearchResultsResultData({});
        setSearchResultsNotFoundError(true);
      }
    });
  };

  const getSearchFormInputDataTypeFromIdentifierSystem = (identifierSystem) => {
    return SEARCH_PARAMETER_TYPES.filter((s) => s.groupLabel == searchPerformedOn)[0].types.filter(
      (t) => t.id === identifierSystem
    )[0];
  };

  return (
    <Link
      sx={{textAlign: 'left'}}
      href="#"
      variant="body2"
      onClick={() => getSimilarResource(searchPerformedOn, resourceId, system.substring(0, system.indexOf(' ')))}
      underline="hover"
    >
      {value}
    </Link>
  );
};

SimilarResourceSearch.propTypes = {
  system: PropTypes.string,
  value: PropTypes.string,
  resourceId: PropTypes.string,
  searchPerformedOn: PropTypes.string,
  rights: PropTypes.object,
  setSearchResultsResultData: PropTypes.func,
  setSearchResultsResourcesData: PropTypes.func,
  setSearchResultsNotFoundError: PropTypes.func,
  setSearchResultsIsSearchResultDataError: PropTypes.func,
  setSearchResultsIsResultDataFetching: PropTypes.func,
  setAppAuthError: PropTypes.func,
  setSearchFormInputData: PropTypes.func,
  setSearchFormInputDataType: PropTypes.func,
  setSearchFormIsOrganizationSearchParameterShown: PropTypes.func,
  setSearchFormIsOrganizationSearchParameterBarOpened: PropTypes.func,
  setSimilarResourceSearchIsSimilarResourceSearch: PropTypes.func,
  setSimilarResourceSearchResourceId: PropTypes.func,
  setSimilarResourceSearchSearchedType: PropTypes.func
};

const mapStateToProps = (state) => ({
  searchPerformedOn: searchPerformedOnSelector(state),
  rights: rightsSelector(state)
});

const mapDispatchToProps = (dispatch) => {
  return {
    setSearchResultsResultData: (data) => dispatch(setResultData(data)),
    setSearchResultsResourcesData: (data) => dispatch(setResourcesData(data)),
    setSearchResultsNotFoundError: (data) => dispatch(setNotFoundError(data)),
    setSearchResultsIsSearchResultDataError: (data) => dispatch(setIsSearchResultDataError(data)),
    setSearchResultsIsResultDataFetching: (data) => dispatch(setIsResultDataFetching(data)),
    setAppAuthError: (error) => dispatch(setAuthError(error)),
    setSearchFormInputData: (data) => dispatch(setInputData(data)),
    setSearchFormInputDataType: (data) => dispatch(setInputDataType(data)),
    setSearchFormIsOrganizationSearchParameterShown: (data) => dispatch(setIsOrganizationSearchParameterShown(data)),
    setSearchFormIsOrganizationSearchParameterBarOpened: (data) =>
      dispatch(setIsOrganizationSearchParameterBarOpened(data)),
    setSearchResultsIsSimilarResourceSearch: (data) => dispatch(setIsSimilarResourceSearch(data)),
    setSimilarResourceSearchIsSimilarResourceSearch: (data) => dispatch(setIsSimilarResourceSearch(data)),
    setSimilarResourceSearchResourceId: (data) => dispatch(setResourceId(data)),
    setSimilarResourceSearchSearchedType: (data) => dispatch(setSearchedType(data))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SimilarResourceSearch);
